<script setup lang="ts">
//new version of components/component/Service/order/OrderDataPriceMobile.vue

import {useStoreBonuses, useStoreIsSpendingBonuses, useStorePrice, useStorePriceLoading} from "~/composables/store/order/mainForm";
import formatPrice from "~/utils/formatPrice";
import {
  useStoreCountMastersInJob,
  useStoreDurationJob,
} from "~/composables/store/order/serviceForm";
const storeDuration = useStoreDurationJob()
const hours = ref(Math.floor(storeDuration.value));
const minutes = ref(Math.round((storeDuration.value - hours.value  ) * 60));
const price = useStorePrice()
// пока идёт пересчёт, показанная сумма относится к прошлому набору параметров или обнулена
const priceLoading = useStorePriceLoading()
const bonuses = useStoreBonuses()
const isSpendingBonuses = useStoreIsSpendingBonuses()
const emit = defineEmits(['next'])
const props = defineProps({
  showOrderBtn: Boolean
})
watch(storeDuration, (val) => {
  hours.value =  Math.floor(val);
  minutes.value = Math.round((val - hours.value) * 60);
}, {immediate: true})

const countMasters = useStoreCountMastersInJob()
const goNext = () => {
  emit('next')
}
</script>

<template>
  <div
      class="bg-white p-5 py-3 shadow-sm"
  >
    <div class="flex items-end justify-between">
      <p class="text-base font-normal mb-auto">{{ $t('product.total.title') }}</p>
      <p v-if="priceLoading" class="skeleton h-7 w-28 rounded-lg"></p>
      <p v-else class="text-2xl font-extrabold">{{ formatPrice(price) }} ₸</p>
    </div>

    <div v-if="!priceLoading && (hours || minutes || countMasters)" class="flex items-center gap-3 mt-1">
      <p v-if="hours || minutes" class="flex items-center gap-1 text-xs text-secondary-800 whitespace-nowrap">
        <span>🕑</span>
        <span>~ {{ hours }} {{ $t('order_page.total.duration.hour') }}<template v-if="minutes"> {{ minutes }} {{ $t('order_page.total.duration.minutes') }}</template></span>
      </p>

      <p v-if="countMasters" class="flex items-center gap-1 text-xs text-secondary-800 whitespace-nowrap">
        <span>🧑🏻</span>
        <span>{{ countMasters }} {{ $t('order_page.total.masters_short') }}</span>
      </p>
    </div>

<!--    <div class="flex flex-col gap-3 mt-6">-->
<!--      <UIBtn-->
<!--          border="green"-->
<!--      >-->
<!--        Поделиться-->
<!--      </UIBtn>-->
<!--      <UIBtn-->
<!--          v-if="showOrderBtn"-->
<!--          @click="goNext"-->
<!--          color="green"-->
<!--      >-->
<!--        {{ $t('cart.controls.make_order') }}-->
<!--      </UIBtn>-->
<!--    </div>-->
  </div>
</template>

<style scoped>

</style>